import { NumberOfSelections } from '@superbet-group/betting.lib.payments';

const MINIMAL_NUMBER_TO_SHOW = 2;

export function isSuperBonusVisible(
    { invalid, tolerated, eligible }: NumberOfSelections,
    isSimpleBetSlipType: boolean,
    minimalNumberToShow = MINIMAL_NUMBER_TO_SHOW,
): boolean {
    if (!isSimpleBetSlipType) {
        return false;
    }
    return eligible > 0 && eligible + tolerated + invalid >= minimalNumberToShow;
}

export function isSuperBonusVisibleOnCompactBetSlip(
    { invalid, tolerated, eligible }: NumberOfSelections,
    isSimpleBetSlipType: boolean,
    minimalNumberToShow = MINIMAL_NUMBER_TO_SHOW,
): boolean {
    if (!isSimpleBetSlipType) {
        return false;
    }
    return eligible > 0 && invalid === 0 && eligible + tolerated >= minimalNumberToShow;
}
